var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFacebook(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "facebook-a",
    colorInterpolationFilters: "auto"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    values: "1 0 0 0 0                 0 1 0 0 0                 0 0 1 0 0                 0 0 0 1 0"
  })), /*#__PURE__*/React.createElement("path", {
    id: "facebook-b",
    d: "M0.002 0.001L31.965 0.001 31.965 31.993 0.002 31.993z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    filter: "url(#facebook-a)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "facebook-c",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#facebook-b"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M31.9647965,16.0943026 C31.9647965,7.20565815 24.8092395,0 15.9823982,0 C7.15555693,0 0,7.20565815 0,16.0943026 C0,24.1274342 5.84453204,30.7856974 13.4851485,31.9930845 L13.4851485,20.7465619 L9.42711771,20.7465619 L9.42711771,16.0943026 L13.4851485,16.0943026 L13.4851485,12.5485265 C13.4851485,8.51489194 15.8712082,6.28683694 19.5219376,6.28683694 C21.270543,6.28683694 23.09956,6.60117878 23.09956,6.60117878 L23.09956,10.5618861 L21.084217,10.5618861 C19.0988098,10.5618861 18.479648,11.802499 18.479648,13.0752692 L18.479648,16.0943026 L22.9122662,16.0943026 L22.2036716,20.7465619 L18.479648,20.7465619 L18.479648,31.9930845 C26.1202644,30.7856974 31.9647965,24.1274342 31.9647965,16.0943026",
    mask: "url(#facebook-c)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/Facebook.2e6ee2fb.svg";
export { ForwardRef as ReactComponent };